<template>
  <div class="main_wrap">
      <div class="login_logo">
        <img src="static/images/logo.png" alt="">
      </div>
      <form method="post" class="login_form">
        <h1 class="login_title">用户登录</h1>
        <input type="text" name="username" placeholder="用户名" class="input_txt" autocomplete="off" v-model="username"  @click="errshow=false">
        <input type="password" name="password" placeholder="密码" class="input_txt" v-model="password"  @click="fnPwd">
        <input type="button" @click='fn' class="yzm_btn" value='输入用户名点击获取验证码'>
        <div id="geetcon" class="geetcon"></div>
        <div class="error_tip" v-show="errshow">{{errmsg}}</div>
        <input id="inp1" type="button" :style='{"background": str2}' :disabled='str1' value="登 录" class="input_sub" @click="fnLogin">
        <!-- <input id="inp1" type="button" value="登 录" class="input_sub" @click="fnLogin"> -->

        <div style="color:red;font-size:12px;padding:80px 8px 0;text-align: center;line-height: 1.5em;">
          仅用于IT培训教学使用，为保障您的个人信息安全，请勿向平台录入任何个人敏感信息（如手机号、身份证号等）！
        </div>
      </form>
  </div>
</template>

<script>
import cons from '@/components/constant'
import gtJS from '@/components/gt'

export default {
  name: 'Login',
  data () {
    return {
      username:'demo',
      password:'ABCdefg123',
      errmsg: '',
      errshow: false,
      result: {
        challenge:'',
        validate:'',
        seccode:''
      },
      str1: 'disabled',
      str2: '#ccc',
      str3: '输入用户名，获取验证码...',
    }
  },
  methods:{
    fnPwd(){
      this.errshow = false;
      if(this.username=='testid'){
        this.str1 = false;
      }
    },
    fnLogin(){
      // initGeetest()
       if(this.username==''||this.password==''){
          this.errmsg = '用户名或密码不能为空';
          this.errshow = true;
          return;
       };
       this.axios.post(cons.apis + '/v1_0/authorizations', {
          account:this.username,
          password:this.password,
          challenge:this.result.geetest_challenge,
          validate:this.result.geetest_validate,
          seccode:this.result.geetest_seccode
        }, {

       //  测试
       // this.axios.get(cons.apis + '/v1_0/authorizations?account='+this.username, {
          withCredentials: true
        })
        .then(response=>{
          // console.log(response);
          // 存储用户登录信息
          sessionStorage.clear();
          localStorage.clear();
          localStorage.token = response.data.data.token;
          // console.log(localStorage.token)
          localStorage.refresh_token = response.data.data.refresh_token;
          localStorage.username = response.data.data.name;
          localStorage.user_id = response.data.data.administrator_id;

          this.$router.push({path:'/home'});
        })
        .catch(error=>{
          this.errmsg = '用户名或密码错误';
          this.errshow = true;
          // 清空内容
          document.getElementById('geetcon').innerHTML = '';
          this.result = []
        });
    },
    fn: function(){
      if(this.username==''){
            this.errmsg = '用户名或密码不能为空';
            this.errshow = true;
            return;
         };

      let _this = this;
      this.axios.get(cons.apis + '/v1_0/captchas/'+this.username,{
          withCredentials: true
        })
            .then(function(dat){
              // console.log(obj, window.initGeetest)
              window.initGeetest({
                gt: dat.data.data.gt,
                challenge: dat.data.data.challenge,
                offline: !dat.data.data.success,
                new_captcha: true,
                product:'float'
              },function(captchaObj){
                  document.getElementById('geetcon').innerHTML = '';
                  captchaObj.appendTo("#geetcon");
                  captchaObj.onReady(function(){
                    //your code
                  }).onSuccess(function(){
                    let result = captchaObj.getValidate();
                    _this.result = result
                    let count = 60;

                    let timer = setInterval(function(){
                      _this.getcode = count + '秒'
                      count--;
                      if(count==0){
                        _this.getcode = '获取验证码';
                        clearInterval(timer);
                      }
                    },1000);
                    // 验证成功按钮变色，并可以点击
                    _this.str1 = false;
                    _this.str2 = 'rgba(247,60,45,0.6)';

                  }).onError(function(){
                    // your code
                  })
              })
            })

    }
  }
}
</script>

<style scoped>
.main_wrap{
  position:fixed;
  width:100%;
  height:100%;
  left:0px;
  top:0px;
  background:linear-gradient(45deg,#facff1,#6db9db);

}
.login_logo{
  background:rgba(47,64,80,0.6);
  height:45px;
}

.login_logo img{
  margin:5px 0 0 10px;
}

.login_form{
  width:330px;
  height:440px;
  background:#fff;
  position:fixed;
  left:50%;
  top:50%;
  margin-top:-220px;
  margin-left:-165px;
  overflow:hidden;
  border-radius:6px;
}
.login_form .error_tip{
  position:absolute;
  font-size:12px;
  color:#f00;
  bottom:106px;
  left:18px;
}
.login_title{
  line-height:72px;
  text-align:center;
  background:linear-gradient(90deg,rgba(246,60,47,0.6),rgba(128,58,242,0.6));
  color:#fff;
  font-size:20px;
}
.input_txt{
  display:block;
  margin:20px auto 0;
  width:298px;
  height:32px;
  border:1px solid #d0d0d0;
  border-radius:4px;
  outline:none;
  text-indent:10px;
}
.forget_pass{
  display:block;
  width:298px;
  margin:10px auto 0;
  text-align:right;
  font-size:14px;
  color:#5195d0;
}
.input_sub{
  /*display:block;*/
  /*margin:40px auto 0;*/
  position: absolute;
  bottom: 65px;
  left: 50%;
  margin-left: -150px;
  width:298px;
  height:32px;
  border:0px;
  border-radius:4px;
  /*background:rgba(247,60,45,0.6);*/
  color:#fff;
  cursor:pointer;
}
/*.input_sub:hover{
  background:rgba(247,60,45,0.4);
}*/

/* 以下遮罩层为demo.用户可自行设计实现 */
#mask {
    display: none;
    position: fixed;
    text-align: center;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    overflow: auto;
}
/* 可自行设计实现captcha的位置大小 */
.popup-mobile {
    position: relative;
}
#popup-captcha-mobile {
    position: fixed;
    display: none;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    z-index: 9999;
}
.geetcon, .yzm_btn {
  display: block;
  width: 300px;
  height: 42px;
  margin: 20px auto 0;
}
.yzm_btn {
  font: 18px 'simsun';
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  background: #eee;
  outline: none;
}
.yzm_btn:hover {
  cursor: pointer;
  border: 1px solid #d0d0d0;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/Login.vue